import { config } from 'zod';

// Strict CSPs report zod's eval-support probe as a securitypolicyviolation even though it's caught internally.
config({ jitless: true });
